import { redirect } from "@sveltejs/kit";
const load = async ({ locals, request }) => {
  let url = request.url.replace("://", "");
  url = url.substring(url.indexOf("/"));
  if (!locals.user && url !== "/admin/login") {
    throw redirect(302, "/admin/login");
  }
  return {
    user: locals.user
  };
};
export {
  load
};
